import React, { useEffect, useState, useContext } from 'react';
import axios from "axios";
import { getBaseUrl } from "../utils";
import { Link, useNavigate } from 'react-router-dom';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from './UserContext';

const Subscription = () => {
    const { subscription } = useContext(UserContext);
    console.log('subscription ====> ', subscription);

    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");

    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [summary, setSummary] = useState(null); // active subscription info from the server
    const [busy, setBusy] = useState(false);

    // Calling Subscription Plans when baseUrl and User Token available
    useEffect(() => {
        const fetchSubscriptionPlans = async () => {
            try {
                const response = await fetch(
                    `${baseUrl}user_api/subscription_plans`,
                    {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json',
                        }
                    }
                );

                const data = await response.json();

                if (data.status) {
                    setPlans(data.data || []);
                    setSummary(data.subscription || null);
                } else {
                    setError(data.message || 'Failed to load subscription plans');
                }

            } catch (err) {
                console.error('Error fetching subscription plans:', err);
                setError('Something went wrong while fetching plans');
            } finally {
                setLoading(false);
            }
        };

        fetchSubscriptionPlans();
    }, [baseUrl, token]);

    // Plan action from the server: current | subscribe | upgrade | unavailable
    const actionOf = (plan) => plan.action || (plan.is_subscribed ? "current" : (plan.price > 0 ? "subscribe" : "unavailable"));
    const cycleLabel = (plan) => (plan.billing_cycle === "yearly" ? "year" : "month");
    const formatDate = (d) => (d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "");

    const postJson = async (path, body) => {
        const response = await fetch(`${baseUrl}user_api/${path}`, {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
            body: JSON.stringify(body || {}),
        });
        let data = {};
        try { data = await response.json(); } catch (e) { /* non-JSON */ }
        if (response.status === 401) data.message = data.message || "Session expired. Please log in again.";
        return data;
    };

    // Subscribe (no paid plan) or Upgrade (higher plan while a paid plan is active)
    const handleSubscribe = async (plan) => {
        if (busy) return;
        const isUpgrade = actionOf(plan) === "upgrade";
        const price = `₹${plan.price}/${cycleLabel(plan)}`;
        const message = isUpgrade
            ? `Upgrade to ${plan.name} for ${price}?\n\n${plan.name} starts right after payment and your current plan ends at the same time. Unused days of the current plan are not refunded.`
            : `Subscribe to ${plan.name} for ${price}?\n\nIt renews automatically every ${cycleLabel(plan)} until you cancel.`;
        if (!window.confirm(message)) return;

        setBusy(true);
        try {
            const data = await postJson("subscriptions/create", { planId: plan._id });
            if (!data.status) {
                toast.error(data.message || "Failed to start the payment");
                return;
            }
            if (data.free) {
                toast.info(data.message || "You are on the Free plan");
                return;
            }
            if (!window.Razorpay) {
                toast.error("Payment screen could not be loaded. Please refresh the page.");
                return;
            }

            const rzp = new window.Razorpay({
                key: data.razorpayKey,
                subscription_id: data.subscriptionId,
                name: "Mr Guru",
                description: `${isUpgrade ? "Upgrade to" : "Subscribe to"} ${plan.name}`,
                handler: async function (response) {
                    try {
                        const verifyData = await postJson("subscriptions/verify", response);
                        if (verifyData.status) {
                            toast.success(verifyData.message || "Subscription activated successfully 🎉");
                        } else {
                            toast.warning(verifyData.message || "We received your payment. Your plan will be activated shortly.");
                        }
                    } catch (err) {
                        toast.warning("We received your payment. Your plan will be activated shortly.");
                    }
                    setTimeout(() => window.location.reload(), 2000);
                },
                modal: { ondismiss: () => toast.info("Payment cancelled") },
                theme: { color: "#0d6efd" },
            });
            rzp.on("payment.failed", (resp) => {
                toast.error(`Payment failed. ${resp?.error?.description || "Please try again."}`);
            });
            rzp.open();
        } catch (err) {
            toast.error("Something went wrong. Please try again.");
        } finally {
            setBusy(false);
        }
    };

    const handleCancel = async (plan) => {
        if (busy) return;
        const endDate = formatDate(plan?.end_date);
        const msg = endDate
            ? `Cancel ${plan.name}?\n\nYour plan will not renew. You can keep using it until ${endDate}.`
            : "Are you sure you want to cancel your subscription?";
        if (!window.confirm(msg)) return;

        setBusy(true);
        try {
            const data = await postJson("subscriptions/cancel");
            if (data.status) {
                toast.success(data.message || "Subscription cancelled");
                setTimeout(() => window.location.reload(), 2000);
            } else {
                toast.error(data.message || "Cancellation failed");
            }
        } catch (err) {
            toast.error("Cancellation failed");
        } finally {
            setBusy(false);
        }
    };

    if (loading) return <div className="text-center mt-5"><label className="Header__text">Loading plans...</label></div>;
    if (error) return <div className="text-center mt-5 text-danger"><label className="Header__text">{error}</label></div>;

    return (
        <div>
            <ToastContainer />
            <div className='container-fluid'>
                {summary?.message && (
                    <div className={`alert ${summary.cancel_at_period_end ? "alert-warning" : "alert-primary"} text-center fw-semibold`}>
                        {summary.plan}: {summary.message}
                    </div>
                )}
                <div className="row row-cols-1 row-cols-md-3 mb-3 text-center justify-content-center">
                    {plans.map((plan) => (
                        // <div className="col" key={plan._id}>
                        //     <div
                        //         className={`card mb-4 rounded-3 shadow-sm ${plan.is_subscribed ? "border-primary" : ""
                        //             }`}
                        //     >
                        //         <div
                        //             className={`card-header py-3 ${plan.is_subscribed ? "text-bg-primary border-primary" : ""
                        //                 }`}
                        //         >
                        //             <h4 className="my-0 fw-normal">{plan.name}</h4>
                        //         </div>

                        //         <div className="card-body">
                        //             {/* MRP Cut & Sales Price Display Block */}
                        //             <div className="d-flex align-items-baseline justify-content-center gap-2 mb-2">
                        //                 {plan.mrp > plan.price && (
                        //                     <span className="text-muted text-decoration-line-through fs-4">
                        //                         ₹{plan.mrp}
                        //                     </span>
                        //                 )}
                        //                 <h1 className="card-title pricing-card-title m-0">
                        //                     ₹{plan.price}
                        //                     <small className="text-body-secondary fw-light fs-5">
                        //                         /{plan.billing_cycle}
                        //                     </small>
                        //                 </h1>
                        //             </div>

                        //             <ul className="list-unstyled mt-3 mb-4">
                        //                 <li>{plan.resume} Resume Access</li>
                        //                 <li>{plan.test} Tests</li>
                        //                 <li>{plan.blog} Blogs</li>
                        //                 <li>{plan.exam_alert} Exam Alerts</li>
                        //                 {plan.counselling > 0 && <li>{plan.counselling} Counselling Calls</li>}
                        //             </ul>

                        //             {plan.is_subscribed ? (
                        //                 <>
                        //                     <button
                        //                         type="button"
                        //                         className="w-100 btn btn-lg btn-outline-primary mb-2"
                        //                     >
                        //                         Current Plan
                        //                     </button>

                        //                     {!plan?.is_default && (
                        //                         <button
                        //                             type="button"
                        //                             className="w-100 btn btn-lg btn-danger"
                        //                             onClick={handleCancel}
                        //                         >
                        //                             Cancel Subscription
                        //                         </button>
                        //                     )}
                        //                 </>
                        //             ) : (
                        //                 <button
                        //                     type="button"
                        //                     className="w-100 btn btn-lg btn-primary"
                        //                     onClick={() =>
                        //                         plan.price === 0
                        //                             ? toast.info("Already Active Plan")
                        //                             : handleSubscribe(plan._id)
                        //                     }
                        //                 >
                        //                     Subscribe Now
                        //                 </button>
                        //             )}
                        //         </div>
                        //     </div>
                        // </div>

                        <div className="col-lg-4 col-md-6 col-12 mb-4" key={plan._id}>
    <div
        className={`card border-0 shadow-lg rounded-4 h-100 position-relative overflow-hidden ${
            plan.is_subscribed ? "border border-primary border-3" : ""
        }`}
    >
        {/* Popular Badge */}
        {plan.is_subscribed && (
            <span
                className="position-absolute top-0 end-0 badge bg-primary px-3 py-2 rounded-0 rounded-bottom-start"
                style={{ zIndex: 2 }}
            >
                Current Plan
            </span>
        )}

        {/* Discount Badge */}
        {plan.mrp > plan.price && (
            <span
                className="position-absolute top-0 start-0 badge bg-danger px-3 py-2 rounded-0 rounded-bottom-end"
                style={{ zIndex: 2 }}
            >
                {Math.round(
                    ((plan.mrp - plan.price) / plan.mrp) * 100
                )}
                % OFF
            </span>
        )}

        {/* Header */}
        <div className="card-header bg-white border-0 pt-5 pb-3 text-center">
            <h3 className="fw-bold mb-2">{plan.name}</h3>

            {plan.mrp > plan.price && (
                <div className="text-decoration-line-through text-muted fs-5">
                    ₹{plan.mrp}
                </div>
            )}

            <div className="d-flex justify-content-center align-items-end mt-1">
                <h1 className="fw-bold text-primary mb-0">
                    ₹{plan.price}
                </h1>

                <span className="text-muted ms-2">
                    /{plan.billing_cycle}
                </span>
            </div>

            {plan.mrp > plan.price && (
                <small className="text-success fw-semibold">
                    You Save ₹{plan.mrp - plan.price}
                </small>
            )}
        </div>

        {/* Features */}
        <div className="card-body">

            <ul className="list-unstyled mb-4">

                <li className="mb-3">
                    ✅ {plan.resume} Resume Access
                </li>

                <li className="mb-3">
                    ✅ {plan.test} Tests
                </li>

                <li className="mb-3">
                    ✅ {plan.blog} Blogs
                </li>

                <li className="mb-3">
                    ✅ {plan.exam_alert} Exam Alerts
                </li>

                {plan.counselling > 0 && (
                    <li className="mb-3">
                        ✅ {plan.counselling} Counselling Calls
                    </li>
                )}

            </ul>
        </div>

        {/* Footer */}
        <div className="card-footer bg-white border-0 pb-4 px-4">

            {actionOf(plan) === "current" ? (
                <>
                    <button className="btn btn-outline-primary w-100 rounded-pill fw-semibold mb-2" disabled>
                        {plan.cancel_at_period_end ? `Active until ${formatDate(plan.end_date)}` : "Current Plan"}
                    </button>
                    {plan.price > 0 && plan.end_date && !plan.cancel_at_period_end && (
                        <small className="d-block text-muted mb-2">Renews on {formatDate(plan.end_date)}</small>
                    )}
                    {plan.can_cancel && (
                        <button
                            className="btn btn-outline-danger w-100 rounded-pill fw-semibold"
                            onClick={() => handleCancel(plan)}
                            disabled={busy}
                        >
                            Cancel Subscription
                        </button>
                    )}
                </>
            ) : actionOf(plan) === "subscribe" || actionOf(plan) === "upgrade" ? (
                <button
                    className="btn btn-primary w-100 rounded-pill fw-semibold py-2"
                    onClick={() => handleSubscribe(plan)}
                    disabled={busy}
                >
                    {plan.action_label || (actionOf(plan) === "upgrade" ? `Upgrade to ${plan.name}` : "Subscribe Now")}
                </button>
            ) : (
                <button className="btn btn-light w-100 rounded-pill fw-semibold py-2" disabled>
                    {plan.action_label || "Not available"}
                </button>
            )}

        </div>
    </div>
</div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Subscription;